import DayExercises from "./DayExercises";

export default DayExercises;
